import { RouteEnum } from 'app/shared/enums';

export const isCalculationForm = () => {
  const { pathname } = window.location;

  return (
    pathname === '/' ||
    pathname === `${RouteEnum.CALCULATION_FORM}` ||
    pathname === `${RouteEnum.CALCULATION_FORM}/` ||
    pathname === `${RouteEnum.HOME}` ||
    pathname === `${RouteEnum.HOME}/` ||
    pathname === `${RouteEnum.CALCULATION}` ||
    pathname === `${RouteEnum.CALCULATION}/` ||
    pathname.startsWith(`/promotion-id/`) ||
    pathname.startsWith(`${RouteEnum.HOME}/promotion-id/`) ||
    pathname.startsWith(`${RouteEnum.HOME}/partners/`) ||
    pathname.endsWith('kalkulator-ubezpieczenia-turystycznego') ||
    pathname.endsWith('kalkulator-ubezpieczenia-turystycznego/') ||
    pathname.endsWith('travel-form') ||
    pathname.endsWith('travel-form/')
  );
};
